import React, { useState } from 'react';
import { Mail, MessageSquare, User } from 'lucide-react';
import { toast } from 'sonner';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    console.log('Form submitted:', formData);
    toast.success('Message sent! I\'ll get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="py-20 lg:py-32 bg-gradient-to-b from-gray-900 to-black relative overflow-hidden">
      <div className="grain-overlay opacity-20"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-pink-accent to-transparent opacity-50"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="section-heading mb-6">
              LET'S CREATE TOGETHER
            </h2>
            <p className="body-large max-w-2xl mx-auto opacity-80">
              Got a project in mind? Want to collaborate? Or just want to talk about web3 and AI? Drop me a line.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Contact Form */}
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="form-group">
                <label htmlFor="name" className="block text-sm font-mono uppercase tracking-wider mb-2 text-pink-accent">
                  <User className="inline mr-2" size={16} />
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white bg-opacity-5 border border-white border-opacity-20 rounded-lg focus:outline-none focus:border-pink-accent transition-colors text-white placeholder-white placeholder-opacity-40"
                  placeholder="John Doe"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="block text-sm font-mono uppercase tracking-wider mb-2 text-pink-accent">
                  <Mail className="inline mr-2" size={16} />
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white bg-opacity-5 border border-white border-opacity-20 rounded-lg focus:outline-none focus:border-pink-accent transition-colors text-white placeholder-white placeholder-opacity-40"
                  placeholder="john@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="block text-sm font-mono uppercase tracking-wider mb-2 text-pink-accent">
                  <MessageSquare className="inline mr-2" size={16} />
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="w-full px-4 py-3 bg-white bg-opacity-5 border border-white border-opacity-20 rounded-lg focus:outline-none focus:border-pink-accent transition-colors text-white placeholder-white placeholder-opacity-40 resize-none"
                  placeholder="Tell me about your project..."
                />
              </div>

              <button
                type="submit"
                className="cta-button large w-full bg-pink-accent text-black border-pink-accent hover:bg-white hover:border-white"
              >
                Send Message
              </button>
            </form>

            {/* Contact Info */}
            <div className="space-y-8 lg:pl-8">
              <div className="bg-white bg-opacity-5 backdrop-blur-sm border border-white border-opacity-10 rounded-lg p-8">
                <h3 className="text-2xl font-bold mb-6">Other Ways to Connect</h3>
                
                <div className="space-y-6">
                  <div>
                    <h4 className="text-sm font-mono uppercase tracking-wider text-pink-accent mb-2">For Collaborations</h4>
                    <p className="opacity-80">collabs@biggiepoppins.xyz</p>
                  </div>
                  
                  <div>
                    <h4 className="text-sm font-mono uppercase tracking-wider text-pink-accent mb-2">For Press & Media</h4>
                    <p className="opacity-80">press@biggiepoppins.xyz</p>
                  </div>
                  
                  <div>
                    <h4 className="text-sm font-mono uppercase tracking-wider text-pink-accent mb-2">For Community</h4>
                    <p className="opacity-80">Join our Discord server</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-pink-accent from-opacity-10 to-transparent p-8 rounded-lg border border-pink-accent border-opacity-20">
                <h4 className="text-xl font-bold mb-4">Open to:</h4>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3">
                    <span className="w-2 h-2 bg-pink-accent rounded-full"></span>
                    <span>NFT & Web3 collaborations</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <span className="w-2 h-2 bg-pink-accent rounded-full"></span>
                    <span>AI art experiments</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <span className="w-2 h-2 bg-pink-accent rounded-full"></span>
                    <span>Speaking engagements</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <span className="w-2 h-2 bg-pink-accent rounded-full"></span>
                    <span>Creative consulting</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
